import Icon from '../components/Icon.vue'

Icon.register({
  'square-root-alt': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M571.3 251.3L548.7 228.7C542.4 222.4 532.3 222.4 526.1 228.7L480 274.8 433.9 228.7C427.7 222.4 417.6 222.4 411.3 228.7L388.7 251.3C382.4 257.6 382.4 267.7 388.7 273.9L434.8 320 388.7 366.1C382.4 372.3 382.4 382.4 388.7 388.7L411.3 411.3C417.6 417.6 427.7 417.6 433.9 411.3L480 365.3 526.1 411.3C532.3 417.6 542.4 417.6 548.7 411.3L571.3 388.7C577.6 382.4 577.6 372.3 571.3 366.1L525.3 320 571.3 273.9C577.6 267.7 577.6 257.6 571.3 251.3zM552 0H307.6C293.1 0 280.4 9.8 276.7 23.9L191.9 346.7 133.5 240.6A32-32 0 0 1 105.5 224H24C10.8 224 0 234.7 0 248V296C0 309.3 10.8 320 24 320H67.6L156.5 483.7C169 503.5 186.3 512 204.9 512 222.2 512 249.4 503 259.2 470.5L357 96H552C565.3 96 576 85.3 576 72V24C576 10.7 565.3 0 552 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/square-root-alt.js
// module id = ShuQ
// module chunks = 144